import React, { useState, useEffect } from "react";
import SideBar from "../SideBar/sideBar";
import axios from "axios";
import { SubcriptionCancel, ActivePlan } from "../api/Service";

const Subscription = () => {
    const PlanTypeName = localStorage.getItem('PlanTypeName') || 'Free';
    const [currentPlan, setCurrentPlan] = useState('');
    const [plans, setPlans] = useState([]);
    const [Active, setActive] = useState('')
    const [loading, setLoading] = useState(true);
    const [status, setStatus] = useState(null)
    const [isModalOpen, setIsModalOpen] = useState(false);

    const FirstName = localStorage.getItem('firstName') || '';
    const LastName = localStorage.getItem('lastName') || '';
    const initials = `${FirstName?.charAt(0)}${LastName?.charAt(0)}`;
    const email = localStorage.getItem('email')

    const ActiveApi = async () => {
        const res = await ActivePlan();
        setActive(res.data.data.subscriptionStatus)
        setCurrentPlan(res.data.data.PlanTypeName)
        //localStorage.setItem('Subscription', res.data.data.subscriptionStatus);
    };

    useEffect(() => {
        ActiveApi();
        setLoading(false);
    }, []);

    const getProducts = async () => {
        try {
            const response = await axios.get('https://aicreditrepair.io//wp-json/wc/v3/products', {
                auth: {
                    username: 'ck_f765896d0a195623a27e83a4d2348c005b28c694',
                    password: 'cs_46ed8e44a46fa460c12e40b688184a7a6116ee6f'
                }
            });
            const sortedPlans = response.data.sort((a, b) => parseFloat(a.price) - parseFloat(b.price));
            setPlans(sortedPlans);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching products:', error);
        }
    };
    // console.log(plans,'plannss')
    // const Plan1 = [
    //     {
    //         name: "Free",
    //         price: "0"
    //     },
    //     {
    //         name: "Elite Plan",
    //         price: "70"
    //     },
    //     {
    //         name: "Lifetime Access",
    //         price: "30"
    //     },
    // ]
    // useEffect(() => {
    //     if (loading) {
    //         setPlans(Plan1)
    //     }
    // }, [loading]);

    useEffect(() => {
        if (loading) {
            getProducts();
        }
    }, [loading]);

    const ConfirmationModal = ({ isOpen, onConfirm, onCancel }) => {
        if (!isOpen) return null;

        return (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                <div className="bg-white p-6 rounded-md shadow-md">
                    <h2 className="text-lg font-bold mb-4">Confirm Cancellation</h2>
                    <p>Are you sure you want to cancel your subscription?</p>
                    <div className="flex justify-end mt-4 space-x-2">
                        <button
                            onClick={onCancel}
                            className="px-4 py-2 bg-gray-300 rounded-md"
                        >
                            No
                        </button>
                        <button
                            onClick={onConfirm}
                            className="px-4 py-2 bg-red-500 text-white rounded-md"
                        >
                            Yes, Cancel
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    const handleCancelClick = () => {
        setIsModalOpen(true);
    };

    const handleConfirm = () => {
        setIsModalOpen(false);
        handleClick();
    };

    const handleCancelModal = () => {
        setIsModalOpen(false);
    };

    const handleClick = async () => {
        try {
            console.log(email, 'frdwdsfsdf')
            let payload = {
                email: email,
            }
            const res = await SubcriptionCancel(payload);
            setStatus(res.status)

        } catch (error) {
            console.log(error, 'Error in canceling subscription')
        }
    }
    return (
        <>
            <div className="flex h-100% bg-[#121212]">
                <SideBar />
                <main className="flex-1 overflow-y-auto p-4 sm:p-6 min-h-screen">
                <div className="flex flex-col md:flex-row justify-between items-center mt-5 mb-4">
                    <h1 className="text-2xl md:text-3xl font-bold text-white">Subscription Management</h1>
                    <div className="ml-0 md:ml-[30.75rem] mt-4 md:mt-0">
                        {PlanTypeName?.includes('Lifetime Access') && (
                            <h1 className="text-white font-semibold">You Have Lifetime Access</h1>
                        )}
                    </div>
                    <div className="w-10 h-10 bg-purple-500 rounded-full flex items-center justify-center mt-4 md:mt-0">
                        <span className="text-white font-bold">{initials}</span>
                    </div>
                </div>
                    <div>
                        <div className="container mx-auto px-4 py-8">
                            <p className="text-lg sm:text-xl sm: text-center text-white">Your current plan: <span className="font-bold text-purple-500">{currentPlan}</span></p>
                            <>
                                {Active === 'Active' ? (
                                    <div className="m-0">
                                        <p className="text-center text-white font-semibold">
                                            {status === 200 ? (
                                                'Subscription Canceled Successfully!!'
                                            ) : (
                                                <a
                                                    onClick={handleCancelClick}
                                                    className="text-blue-600 underline cursor-pointer"
                                                >
                                                    Cancel Subscription
                                                </a>
                                            )}
                                        </p>
                                    </div>
                                ) : null}

                                {/* Modal */}
                                <ConfirmationModal
                                    isOpen={isModalOpen}
                                    onConfirm={handleConfirm}
                                    onCancel={handleCancelModal}
                                />
                            </>
                            <div class="text-white font-sans p-4 grid grid-cols-1  gap-2 sm:gap-[5rem]">
                                {plans.map((plan, index) => (
                                    plan.name?.includes('Lifetime Access') && (
                                        <div key={index} className="max-w-6xl mx-auto">
                                            <div className="flex flex-row justify-center items-stretch gap-6 flex-wrap"> {/* Updated to flex-row and added flex-wrap for responsiveness */}
                                                <div className="flex p-6 relative h-[504px] bg-[#1B144B] flex-col justify-between rounded-2xl min-w-[300px]"> {/* Added min-width for better horizontal scaling */}
                                                    {plan.name === 'Elite Plan' && <div className="absolute top-0 right-0 bg-[#8257e6] text-white text-sm font-bold py-1 px-3 rounded-tr-2xl rounded-bl-2xl">Most Popular</div>}
                                                    {plan.name?.includes('Lifetime Access') &&
                                                        <div className="absolute top-0 right-0 bg-[#8257e6] text-white text-sm font-bold py-1 px-3 rounded-tr-2xl rounded-bl-2xl">Limited Time Offer</div>}
                                                    <div>

                                                        <h2 className="text-2xl font-bold mb-2">{plan.name}</h2>
                                                        {plan.name?.includes('Lifetime Access') ? (<p className="text-4xl font-bold mb-6">${plan.price}</p>) : (<p className="text-4xl font-bold mb-6">${plan.price}/mo</p>)}

                                                        {plan.name === 'Fre' ? (
                                                            <>
                                                                <div>
                                                                    <ul className="space-y-2 mb-6">
                                                                        <li className="flex items-center">
                                                                            <i className="fas fa-check text-[#8257e6] mr-2"></i>
                                                                            Credit Card Utilization Scorer
                                                                        </li>
                                                                        <li className="flex items-center">
                                                                            <i className="fas fa-check text-[#8257e6] mr-2"></i>
                                                                            2 Credit Cards Only
                                                                        </li>
                                                                        <li className="flex items-center line-through text-gray-500">
                                                                            <i className="fas fa-check text-[#8257e6] mr-2"></i>
                                                                            AI Recommendation
                                                                        </li>
                                                                        <li className="flex items-center line-through text-gray-500">
                                                                            <i className="fas fa-check text-[#8257e6] mr-2"></i>
                                                                            Remove Public Records
                                                                        </li>
                                                                        <li className="flex items-center line-through text-gray-500">
                                                                            <i className="fas fa-check text-[#8257e6] mr-2"></i>
                                                                            AI Dispute Letter Generator
                                                                        </li>
                                                                        <li className="flex items-center line-through text-gray-500">
                                                                            <i className="fas fa-check text-[#8257e6] mr-2"></i>
                                                                            Remove Public Property Data
                                                                        </li>
                                                                        <li className="flex items-center line-through text-gray-500">
                                                                            <i className="fas fa-check text-[#8257e6] mr-2"></i>
                                                                            Send Mail From Platform
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                                <div className="mt-[90px]">
                                                                    <a href="#" rel="noopener noreferrer" className="centerbtn w-full py-3 rounded-full font-bold text-center px-8 bg-[#3a1466] hover:opacity-90 transition-opacity">Get Started</a>
                                                                </div></>
                                                        ) : plan.name?.includes('Lifetime Access') ? (
                                                            <>
                                                                <div>
                                                                    <ul className="space-y-2 mb-6">
                                                                        <li className="flex items-center">
                                                                            <i className="fas fa-check text-[#8257e6] mr-2"></i>
                                                                            Credit Card Utilization Scorer
                                                                        </li>
                                                                        <li className="flex items-center">
                                                                            <i className="fas fa-check text-[#8257e6] mr-2"></i>
                                                                            Unlimited Credit Cards
                                                                        </li>
                                                                        <li className="flex items-center">
                                                                            <i className="fas fa-check text-[#8257e6] mr-2"></i>
                                                                            AI Recommendations
                                                                        </li>
                                                                        <li className="flex items-center">
                                                                            <i className="fas fa-check text-[#8257e6] mr-2"></i>
                                                                            Remove Public Records
                                                                        </li>
                                                                        <li className="flex items-center">
                                                                            <i className="fas fa-check text-[#8257e6] mr-2"></i>
                                                                            AI Dispute Letter Generator
                                                                        </li>
                                                                        <li className="flex items-center">
                                                                            <i className="fas fa-check text-[#8257e6] mr-2"></i>
                                                                            Remove Public Property Data
                                                                        </li>
                                                                        <li className="flex items-center">
                                                                            <i className="fas fa-check text-[#8257e6] mr-2"></i>
                                                                            Send Mail From Platform
                                                                        </li><li className="flex items-center">
                                                                            <i className="fas fa-check text-[#8257e6] mr-2"></i>
                                                                            Lifetime AI Updates
                                                                        </li><li className="flex items-center">
                                                                            <i className="fas fa-check text-[#8257e6] mr-2"></i>
                                                                            No Recurring Payments
                                                                        </li>
                                                                    </ul>
                                                                </div>


                                                                {currentPlan?.includes('Lifetime Access') ? (
                                                                    <a
                                                                        href="#"
                                                                        rel="noopener noreferrer"
                                                                        className="centerbtn w-full py-3 px-8 rounded-full font-bold text-center bg-[#3a1466] hover:opacity-90 transition-opacity cursor-not-allowed opacity-50"
                                                                        onClick={(e) => e.preventDefault()} // Prevent default action when disabled
                                                                    >
                                                                        Get Lifetime Access
                                                                    </a>
                                                                ) : (
                                                                    <a
                                                                        href="https://aicreditrepair.io/step/lifetime-access/"
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                        className="centerbtn w-full py-3 px-8 rounded-full font-bold text-center bg-[#3a1466] hover:opacity-90 transition-opacity"
                                                                    >
                                                                        Get Lifetime Access
                                                                    </a>
                                                                )}


                                                            </>
                                                        ) : plan.name === 'Elit Plan' ? (
                                                            <>

                                                                <ul className="space-y-2 mb-6">
                                                                    <li className="flex items-center">
                                                                        <i className="fas fa-check text-[#8257e6] mr-2"></i>
                                                                        Credit Card Utilization Scorer
                                                                    </li>
                                                                    <li className="flex items-center">
                                                                        <i className="fas fa-check text-[#8257e6] mr-2"></i>
                                                                        Unlimited Credit Cards Only
                                                                    </li>
                                                                    <li className="flex items-center">
                                                                        <i className="fas fa-check text-[#8257e6] mr-2"></i>
                                                                        AI Recommendations
                                                                    </li>
                                                                    <li className="flex items-center">
                                                                        <i className="fas fa-check text-[#8257e6] mr-2"></i>
                                                                        Remove Public Records
                                                                    </li>
                                                                    <li className="flex items-center">
                                                                        <i className="fas fa-check text-[#8257e6] mr-2"></i>
                                                                        AI Dispute Letter Generator
                                                                    </li>
                                                                    <li className="flex items-center">
                                                                        <i className="fas fa-check text-[#8257e6] mr-2"></i>
                                                                        Remove Public Property Data
                                                                    </li>
                                                                    <li className="flex items-center">
                                                                        <i className="fas fa-check text-[#8257e6] mr-2"></i>
                                                                        Send Mail From Platform
                                                                    </li>
                                                                </ul>
                                                                <div className="mt-[90px]">
                                                                    {currentPlan === 'Elite Plan' ? (<><a href="#" rel="noopener noreferrer" className="centerbtn w-full py-3 px-8 rounded-full font-bold text-center bg-[#8257e6] hover:opacity-90 transition-opacity">Choose Plan</a></>) : (<><a href="https://aicreditrepair.io/step/elite-plan/" target="_blank" rel="noopener noreferrer" className="centerbtn w-full py-3 px-8 rounded-full font-bold text-center bg-[#8257e6] hover:opacity-90 transition-opacity">Choose Plan</a></>)}
                                                                </div>
                                                            </>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                ))}
                            </div>

                        </div>
                        <iframe style={{ width: '100%', height: '1400px' }} className="text-white" src="https://www.create.xyz/app/53df3921-fff7-448d-bf55-04d027933c48" title="Animated FAQ Section" frameBorder="0"></iframe>
                    </div>
                </main>
            </div>
        </>
    )
}

export default Subscription;